import PropTypes from 'prop-types';
import { Icon } from '@bwoty-web/ui-kit';
import { ICON_COMMS_REVIEW } from '@bwoty-web/ui-kit/icons';
import './guestReview.scss';

const MAX_RATING = 5;
const MAX_NUMBER_TEXT_CHARACTERS = 60;

const GuestReview = ({ review = null, labels }) => {
  if (!review) {
    return null;
  }
  const { rating, body, member, date } = review;
  const emptyAlias = '[NE__ANONYMOUS]';
  const aliasToDisplay =
    member.alias === emptyAlias ||
    member?.alias === undefined ||
    member?.alias === ''
      ? labels.aliasPlaceholder
      : member.alias;
  const guestReviewFooterText = `${aliasToDisplay}, ${date.long}`;
  const truncateGuestReviewText =
    body?.length > MAX_NUMBER_TEXT_CHARACTERS
      ? `" ${body?.substring(0, MAX_NUMBER_TEXT_CHARACTERS)}... "`
      : `" ${body} "`;

  return (
    <div className="gw-guest-review__container">
      <div className="gw-guest-review__header-wrap">
        <div className="gw-guest-review-rating__icon">
          <Icon
            className="gw-guest-review-star__icon"
            path={ICON_COMMS_REVIEW}
            size="s"
            sizeMobile="xs"
            aria-hidden="true"
          />
        </div>
        <div className="gw-guest-review-rating">
          {rating}/{MAX_RATING}
        </div>
      </div>
      <span className="gw-guest-review__body">{truncateGuestReviewText}</span>
      <span className="gw-guest-review-footer">{guestReviewFooterText}</span>
    </div>
  );
};
GuestReview.propTypes = {
  labels: PropTypes.shape({
    aliasPlaceholder: PropTypes.string,
  }).isRequired,
  review: PropTypes.shape({
    rating: PropTypes.number,
    body: PropTypes.string,
    member: PropTypes.shape({
      id: PropTypes.string,
      alias: PropTypes.string,
    }),
    date: PropTypes.shape({
      long: PropTypes.string,
      raw: PropTypes.string,
    }),
  }),
};

export default GuestReview;
